import React from 'react';
import { STUDENT_COLUMNS } from '../../lib/studentTable';
import { orDash } from '../../lib/format';

const ARIA_SORT = { asc: 'ascending', desc: 'descending' };

const NO_SELECTION = new Set();

const cellClass = (c, s) => {
  if (c.className) return c.className(s);
  return c.numeric ? 'td-table__num' : undefined;
};

/**
 * A students table, already sorted by the caller. Every sortable header
 * sorts; a name opens the profile. `columns` (lib/studentTable.js) decides
 * what each cell shows; the Students tab's are the default. With
 * `selectable` (the Students tab) a checkbox column feeds group changes;
 * the Overview's drill-downs pass false and get no checkboxes.
 */
const StudentsTable = ({
  students, sort, onSort, selected = NO_SELECTION, onToggle, onToggleAll, onOpenStudent,
  columns = STUDENT_COLUMNS, selectable = true, label,
}) => {
  const allSelected = selectable && students.length > 0 && students.every((s) => selected.has(s.id));

  return (
    <div className="td-tablewrap">
      <table className="td-table td-table--students" aria-label={label}>
        <thead>
          <tr>
            {selectable ? (
              <th scope="col" className="td-table__check">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={() => onToggleAll(!allSelected)}
                  aria-label="Select all students"
                />
              </th>
            ) : null}
            {columns.map((c) => (
              <th
                key={c.key}
                scope="col"
                className={c.numeric ? 'td-table__num' : undefined}
                aria-sort={sort.key === c.key ? ARIA_SORT[sort.direction] : 'none'}
              >
                {c.sortable === false ? c.label : (
                  <button type="button" className="td-sort" onClick={() => onSort(c.key)}>
                    {c.label}
                    {sort.key === c.key ? <span aria-hidden="true">{sort.direction === 'asc' ? ' ↑' : ' ↓'}</span> : null}
                  </button>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {students.map((s) => (
            <tr key={s.id} className={selectable && selected.has(s.id) ? 'td-table__row--selected' : undefined}>
              {selectable ? (
                <td className="td-table__check">
                  <input
                    type="checkbox"
                    checked={selected.has(s.id)}
                    onChange={() => onToggle(s.id)}
                    aria-label={`Select ${s.name}`}
                  />
                </td>
              ) : null}
              {columns.map((c) => (c.isStudent ? (
                <td key={c.key}>
                  <button type="button" className="td-table__name td-linkbtn" onClick={() => onOpenStudent(s.id)}>
                    {orDash(s.name)}
                  </button>
                  <span className="td-table__email">{orDash(s.email)}</span>
                </td>
              ) : (
                <td key={c.key} className={cellClass(c, s)}>
                  {c.render ? c.render(s) : c.value(s)}
                </td>
              )))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StudentsTable;
